import React from 'react';
import { Link } from 'react-router-dom';
import './HomeComponents.css';

function FeaturedListings({ listings }) {
  // Get 6 listings sorted by views (most viewed first) as featured listings
  const featuredListings = [...listings]
    .sort((a, b) => b.views - a.views)
    .slice(0, 6);

  return (
    <div className="featured-listings">
      <div className="listings-grid">
        {featuredListings.map(listing => (
          <Link to={`/listing/${listing.id}`} key={listing.id} className="listing-card">
            <div className="listing-image">
              <img src={listing.imageUrl} alt={listing.title} />
              {listing.isAuction && (
                <div className="auction-badge">Auction</div>
              )}
            </div>
            <div className="listing-info">
              <h3 className="listing-title">{listing.title}</h3>
              <div className="listing-price">
                {listing.isAuction 
                  ? `Current Bid: HK$${listing.currentBid}`
                  : `HK$${listing.price}`
                }
              </div>
              <div className="listing-details">
                <span className="listing-condition">{listing.condition}</span>
                <span className="listing-location">{listing.location}</span>
              </div>
              <div className="listing-seller">
                Seller: {listing.sellerUsername}
              </div>
            </div>
          </Link>
        ))}
      </div>
      
      <div className="view-all-container">
        <Link to="/browse" className="view-all-button">
          View All Listings
        </Link>
      </div>
    </div>
  );
}

export default FeaturedListings; 